import calendario from './calendario.js'
import calculadora from './calculadora.js'
import liquidacion from './liquidacion.js'


const state = {

}

const actions = {

}

const mutations = {

}

const getters = {

}

const modules = {
    calendario,
    calculadora,
    liquidacion,
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
    modules
}